import { Box } from "@eworkit/iris";
import React, { FC, useMemo, useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { RoutedTabPanels, useRouter } from "router";

import { AnimatedLayoutModal } from "@/components/animated-layout";
import { Tabs } from "@/eworkitComponents";
import { SessionLogin } from "@/views/Session/Login";
import { SessionSignUpUser } from "@/views/Session/SignUpUser";

import { ErrorModal } from "./ErrorModal";

import "./auth.scss";

interface IAuthProps {}

export const SessionAuth: FC<IAuthProps> = React.memo(() => {
  const { t } = useTranslation("public");
  const location = useLocation<any>();
  const { searchParams } = useRouter<any, any>();
  const [openModal, setOpenModal] = useState(location.state && location.state.error);

  const meta =
    searchParams.tab === "login"
      ? {
          title: "META.LOGIN.TITLE",
          description: "META.LOGIN.DESCRIPTION",
        }
      : {
          title: "META.REGISTRATION.TITLE",
          description: "META.REGISTRATION.DESCRIPTION",
        };

  const tabPanels = useMemo(
    () => ({
      login: () => (
        <SessionLogin
          jobRequestId={searchParams.jobRequestId}
          oAuthRedirectUriQueryString={`jobRequestId=${searchParams.jobRequestId}`}
        />
      ),
      registerForm: () => <SessionSignUpUser jobRequestId={searchParams.jobRequestId} />,
    }),
    [searchParams],
  );
  return (
    <>
      <Helmet>
        <title>{t(meta.title)}</title>
        <meta name="description" content={t(meta.description)} />
      </Helmet>

      <AnimatedLayoutModal size={searchParams.tab === "login" ? "sm" : "md"}>
        <Box px={["sm", null, "xxl"]}>
          <Tabs innerBorder={searchParams.tab !== "registerForm"} className="auth__tabs">
            <RoutedTabPanels routeParam="tab" views={tabPanels} />
          </Tabs>

          {location.state && (
            <ErrorModal onClose={() => setOpenModal(false)} open={openModal} error={location.state.error} size="xs" />
          )}
        </Box>
      </AnimatedLayoutModal>
    </>
  );
});

export default SessionAuth;
